
define('text!templates/bin_header.html',[],function () { return '';});

